import { useEffect } from 'react';
import { Link } from 'react-router-dom';

import { Table } from '@/common/components/Table/component.tsx';
import { useRewardsProvider } from '@/common/providers/RewardsProvider/provider.tsx';
import { PageTitle } from '@/common/components/PageTitle/component.tsx';
import { currencyFormat, minifyString } from '@dor/utils';
import { ViewLayout } from '@/common/components/ViewLayout/component.tsx';
import { DeploymentDAGExplorerBaseUrl } from '@/common/consts/api.ts';

import styles from './view.module.scss';

export const RewardsListView = () => {
  const rewards = useRewardsProvider();

  useEffect(() => {
    rewards.rewards.fetch({}, {}, { pageSize: 10 });
  }, []);

  return (
    <ViewLayout>
      <PageTitle>All Rewards</PageTitle>
      <div className={styles.information}>
        <Table
          title="DOR Commissions"
          columns={[
            { key: 'toAddress', title: 'Sent to', style: 'link' },
            { key: 'ordinal', title: 'Ordinal', style: 'link' },
            { key: 'amount', title: 'amount' }
          ]}
          data={rewards.rewards.resource.resource.map((reward) => ({
            toAddress: (
              <a
                href={`${DeploymentDAGExplorerBaseUrl}/address/${reward.address}`}
                target="_blank"
              >
                {minifyString(reward.address, 5, 5)}
              </a>
            ),
            ordinal: (
              <Link to={`/snapshots/${reward.snapshotOrdinal}`}>
                {reward.snapshotOrdinal}
              </Link>
            ),
            amount: currencyFormat('DOR', reward.amount, 'DECIMAL', 8)
          }))}
          pagination={{
            currentPage: rewards.rewards.pagination.currentPage,
            pageSize: rewards.rewards.pagination.pageSize,
            totalPages: rewards.rewards.pagination.totalPages,
            totalItems: rewards.rewards.pagination.totalItems,
            onPageChange: (pageNumber) => rewards.rewards.goToPage(pageNumber)
          }}
        />
      </div>
    </ViewLayout>
  );
};
